import { render, staticRenderFns } from "./editDischargeFollowUp.vue?vue&type=template&id=47cce2f5&scoped=true"
import script from "./editDischargeFollowUp.vue?vue&type=script&lang=js"
export * from "./editDischargeFollowUp.vue?vue&type=script&lang=js"
import style0 from "./editDischargeFollowUp.vue?vue&type=style&index=0&id=47cce2f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cce2f5",
  null
  
)

export default component.exports